import React from "react";
import "./errorpage.css";
import Error401Icon from "../../assets/img/svg/x401errorimage.svg";
import { useNavigate } from "react-router-dom";

const ErrorAuthorization = () => {
  const navigate = useNavigate();

  return (
    <div className="error-pages-container">
      <img src={Error401Icon} alt="404 Error"></img>
      <h1>Your Authorization failed</h1>
      <p>
        <strong>Error 401 :</strong> Please Try refreshing the page and fill in the correct login details.
      </p>

      <button onClick={() => navigate("/")} className="error-accept-button">
        Back To Home Page
      </button>
    </div>
  );
};

export default ErrorAuthorization;
